import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=30b708bd&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30b708bd')) {
      api.createRecord('30b708bd', component.options)
    } else {
      api.reload('30b708bd', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=30b708bd&", function () {
      api.rerender('30b708bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2qHdDVjYNwbVK/JS/pricehelp.vue"
export default component.exports